import {
  CommonApplicationEligibility,
  CommonApplicationEligibilityReason,
} from '@features/user/types/common-application-eligibility';

/**
 * The note above greyed-out savings products:
 * - checking-required: no checking yet; links to the Rails checking page.
 * - pending: the checking application is still being processed.
 * - account-not-approved: the user is pending, in review or rejected.
 * - account-held: the user is on hold.
 */
export type SavingsUnavailableReason =
  'checking-required' | 'pending' | 'account-not-approved' | 'account-held';

/**
 * Which note to show for the profile's common application eligibility, or
 * null for none.
 */
export function getSavingsUnavailableReason({
  canApply,
  reason,
}: Pick<
  CommonApplicationEligibility,
  'canApply' | 'reason'
>): SavingsUnavailableReason | null {
  if (canApply) {
    return null;
  }
  if (reason === CommonApplicationEligibilityReason.CHECKING_PROCESSING) {
    return 'pending';
  }
  if (reason === CommonApplicationEligibilityReason.CHECKING_REQUIRED) {
    return 'checking-required';
  }
  if (reason === CommonApplicationEligibilityReason.ACCOUNT_NOT_APPROVED) {
    return 'account-not-approved';
  }
  if (reason === CommonApplicationEligibilityReason.ACCOUNT_HELD) {
    return 'account-held';
  }
  return null;
}
